import { type FileDownload } from 'components/DynamicDownload/interfaces';

import { extractNameAndTypeFromUrl } from './extractNameAndType';
import { hasExtension } from './validations';

export const createFileDownloadFromUrl = (
  id: number | string,
  url: string,
  customName?: string
): FileDownload => {
  const { name, type } = extractNameAndTypeFromUrl(url);
  const customFileName = customName
    ? hasExtension(customName)
      ? customName
      : `${customName}.${type}`
    : undefined;

  return {
    id,
    name: customFileName || name,
    url,
    type,
  };
};

export const createFileDownloadFromBase64 = (
  id: number,
  base64: string,
  customName?: string
): FileDownload => {
  const base64WithPrefix = `data:image/png;base64,${base64}`;
  const finalName = customName
    ? hasExtension(customName)
      ? customName
      : `${customName}.png`
    : 'test.png';

  return {
    id,
    name: finalName,
    url: base64WithPrefix,
    type: 'png',
  };
};
